import Vue from 'vue';
import Mixin from './../../utils/mixin';
import { i18n } from './../../plugins/i18n';
const loadState = () => ({
    cartLoaded: false,
    cartPrice: 0,
    cartDeliveryPrice: 0,
    cartGroupDeliveryPrice: 0,
    cartAllPrice: 0,
    cartProducts: [],
    cartGroups: [],
    cartShops: [],
    tempUserId: localStorage.getItem('shopTempUserId') || null,
    checkoutCartGroups: [],
});
export default {
    namespaced: true,
    state: loadState(),
    getters: {
        isThisInCart: (state) => (variation_id) => {
            return state.cartProducts.some((cartProduct) => cartProduct.variation_id === variation_id);
        },
        findCartItemByVariationId: (state) => (variation_id) => {
            return state.cartProducts.find((cartProduct) => cartProduct.variation_id === variation_id);
        },
        findCartItemByCartId: (state) => (cart_id) => {
            return state.cartProducts.find((cartProduct) => cartProduct.cart_id === cart_id);
        },
        getTempUserId(state) {
            return state.tempUserId;
        },
        getAllCouponCodes(state) {
            return state.cartShops.map((shop) => shop.couponCode).filter((code) => code);
        },
        getCouponCode: (state) => (shop_id) => {
            if (state.cartShops.length === 0) return null;
            if (shop_id) {
                const shop = state.cartShops.find((shop) => shop.id == shop_id);
                return shop ? shop.couponCode : null;
            } else {
                return state.cartShops[0].couponCode || null;
            }
        },
        getCouponDetails(state) {
            return state.couponDetails;
        },
        getShopCouponDetails: (state) => (shop_id) => {
            if (state.cartShops.length === 0) return null;
            const shop = shop_id
                ? state.cartShops.find((s) => s.id == shop_id)
                : state.cartShops[0];
            return shop ? shop.couponDetails || null : null;
        },
        getShopCouponDiscount: (state) => (shop_id) => {
            if (state.cartShops.length === 0) return 0;
            const shop = shop_id
                ? state.cartShops.find((s) => s.id == shop_id)
                : state.cartShops[0];
            return shop ? shop.couponDiscount || 0 : 0;
        },
        getTotalCouponDiscount(state) {
            let total = 0;
            state.cartShops.forEach((shop) => {
                total += shop.couponDiscount || 0;
            });
            return total;
        },
        getCartCount(state) {
            return state.cartProducts.length;
        },
        getCartAllPrice(state) {
            let total = 0;
            state.cartProducts.forEach((item) => {
                total += item.dicounted_price * item.qty;
            });
            return (state.cartAllPrice = total);
        },
        getCartPrice(state) {
            let total = 0;
            state.cartProducts.forEach((item) => {
                if (item.selected) total += item.dicounted_price * item.qty;
            });
            return (state.cartPrice = total);
        },
        getDeliveryPrice(state) {
            let total = 0;
            state.cartProducts.forEach((item) => {
                if (item.is_selected == '1') {
                    total += item.product_options.parcel_price;
                }
            });

            return (state.cartDeliveryPrice = total);
        },
        getGroupDeliveryPrice(state) {
            let total = 0;
            state.cartGroups.forEach((group) => {
                if (group.is_selected == '1') {
                    total += group.bundle_delivery_price;
                }
            });

            return (state.cartGroupDeliveryPrice = total);
        },
        getCartTax(state) {
            let total = 0;
            state.cartProducts.forEach((item) => {
                if (item.selected) total += item.tax * item.qty;
            });
            return total;
        },
        getCartGroups(state) {
            return state.cartGroups;
        },
        getCartProducts(state) {
            return state.cartProducts;
        },
        getCartShops(state) {
            return state.cartShops;
        },
        getShopProductsById: (state) => (shop_id) => {
            return state.cartProducts.filter((item) => item.shop_id == shop_id);
        },
        getShopCartTotalPrice: (state) => (shop_id) => {
            let total = 0;
            state.cartProducts.forEach((item) => {
                if (item.shop_id == shop_id && item.selected) total += item.dicounted_price * item.qty;
            });
            return total;
        },
        getShopCartPrice: (state) => (shop_id) => {
            let total = 0;
            let shop = state.cartShops.find((shop) => shop.id == shop_id);
            state.cartProducts.forEach((item) => {
                if (item.shop_id == shop_id && item.selected) total += item.dicounted_price * item.qty;
            });
            return total - shop.couponDiscount;
        },
        getShopMinOrder:
            (state) =>
            (shop_id = null) => {
                return shop_id ? state.cartShops.find((shop) => shop.id == shop_id).min_order : state.cartShops[0]?.min_order;
            },
        getStandardTime(state) {
            let selectedProducts = state.cartProducts.filter((item) => item.selected);
            if (selectedProducts.length > 0) {
                let min = Math.ceil(Math.min(...selectedProducts.map((item) => item.standard_delivery_time)) / 24);
                let max = Math.ceil(Math.max(...selectedProducts.map((item) => item.standard_delivery_time)) / 24);
                return min !== max ? min + '-' + max : min;
            } else {
                return 0;
            }
        },
        getExpressTime(state) {
            let selectedProducts = state.cartProducts.filter((item) => item.selected);
            if (selectedProducts.length > 0) {
                let min = Math.ceil(Math.min(...selectedProducts.map((item) => item.express_delivery_time)) / 24);
                let max = Math.ceil(Math.max(...selectedProducts.map((item) => item.express_delivery_time)) / 24);
                return min !== max ? min + '-' + max : min;
            } else {
                return 0;
            }
        },
        getCartIds(state) {
            return state.cartProducts.map((item) => item.cart_id);
        },
        getCartTotal: (state) => (shopId) => {
            let total = 0;
            if (shopId) {
                // 특정 샵의 선택된 상품들의 총액
                state.cartProducts.forEach((item) => {
                    if (item.selected && item.shop_id == shopId) {
                        total += item.dicounted_price * item.qty;
                    }
                });
            } else {
                // 모든 선택된 상품들의 총액
                state.cartProducts.forEach((item) => {
                    if (item.selected) {
                        total += item.dicounted_price * item.qty;
                    }
                });
            }
            return total;
        },
        getSelectedCartIds(state) {
            return state.cartProducts.filter((item) => item.selected && item.is_selected == '1').map((item) => item.cart_id);
        },
        getSelectedCartIdsByShopId: (state) => (shop_id) => {
            return state.cartProducts.filter((item) => item.shop_id == shop_id && item.selected).map((item) => item.cart_id);
        },
        checkShopMinOrder: (state, getters) => {
            let result = { success: true, message: null };
            state.cartShops.forEach((shop) => {
                if (shop.selected && shop.min_order > 0) {
                    let total = 0;
                    state.cartProducts.forEach((item) => {
                        if (item.shop_id == shop.id && item.selected) total += item.dicounted_price * item.qty;
                    });
                    let shopCartPrice = total - shop.couponDiscount;

                    if (shopCartPrice < shop.min_order) {
                        result = {
                            success: false,
                            message: `${i18n.t('you_need_to_reach')} ${Mixin.methods.format_price(parseFloat(shop.min_order))} ${i18n.t('to_place_order_from')} ${shop.name}`,
                        };
                    }
                }
            });
            return result;
        },
        getCheckoutShopProductsById: (state) => (shop_id) => {
            let data = state.cartProducts.filter((item) => item.is_selected === '1');
            return data;
        },
        getCheckoutCartPrice(state) {
            let total = 0;
            state.cartProducts.forEach((item) => {
                if (item.is_selected == '1') total += item.dicounted_price * item.qty;
            });
            return (state.cartPrice = total);
        },
        getTotalProductDiscount(state) {
            let total = 0;
            state.cartProducts.forEach((item) => {
                if (item.is_selected == '1' && item.regular_price && item.dicounted_price) {
                    const discountAmount = (item.regular_price - item.dicounted_price) * item.qty;
                    if (discountAmount > 0) {
                        total += discountAmount;
                    }
                }
            });
            return total;
        },

        //결제시 묶음주문 장바구니 정보
        getCheckoutCartGroups(state) {
            let checkoutCartGroups = [];

            state.cartGroups.forEach((group, g_index) => {
                if (group.is_selected == '1') {
                    if (!checkoutCartGroups[g_index]) {
                        checkoutCartGroups[g_index] = {};
                    }

                    var cart_items = [];
                    group.orders.forEach((cart, c_index) => {
                        if (cart.is_selected == '1') {
                            cart_items.push(cart.cart_id);
                        }
                    });

                    checkoutCartGroups[g_index]['items'] = cart_items;
                    checkoutCartGroups[g_index]['bundle_delivery_price'] = group.bundle_delivery_price;
                    checkoutCartGroups[g_index]['total_weight'] = group.total_weight;
                }
            });

            return (state.checkoutCartGroups = checkoutCartGroups);
        },
    },
    mutations: {
        setTempUserId(state, temp_user_id) {
            state.tempUserId = temp_user_id;
            localStorage.setItem('shopTempUserId', temp_user_id);
        },
        removeTempUserId(state) {
            state.tempUserId = null;
            localStorage.removeItem('shopTempUserId');
        },
        setCartProducts(state, data) {
            state.cartLoaded = true;
            state.cartProducts = data.map((cartProduct) => {
                cartProduct.selected = cartProduct.stock && cartProduct.is_selected == '1' ? true : false;
                cartProduct.outOfStock = cartProduct.stock ? false : true;
                cartProduct.max_qty = cartProduct.max_qty > 0 ? cartProduct.max_qty : Infinity;
                return cartProduct;
            });
        },
        setCartGroups(state, data) {
            state.cartLoaded = true;
            state.cartGroups = data.map((cartGroup) => {
                state.cartProducts = cartGroup.orders.map((cartProduct) => {
                    cartProduct.selected = cartProduct.stock && cartProduct.is_selected == '1' ? true : false;
                    return cartProduct;
                });

                return cartGroup;
            });
        },
        setCartShops(state, data) {
            const oldShops = state.cartShops;
            state.cartShops = data.map((cartShop) => {
                // 기존 샵의 쿠폰 데이터 보존
                const existing = oldShops.find(s => s.id == cartShop.id);
                cartShop.selected = true;
                cartShop.couponCode = existing ? existing.couponCode : null;
                cartShop.couponDetails = existing ? existing.couponDetails : {};
                cartShop.couponDiscount = existing ? existing.couponDiscount : 0;
                return cartShop;
            });
        },
        updateCartShops(state, data = {}) {
            //for adding shop
            if (!Mixin.methods.is_empty_obj(data) && !state.cartShops.some((productShop) => productShop.id == data.id)) {
                data.selected = true;
                data.couponCode = null;
                data.couponDetails = {};
                data.couponDiscount = 0;
                state.cartShops.push(data);
            } else {
                let shopIds = state.cartProducts.map((cartProduct) => cartProduct.shop_id);
                state.cartShops = state.cartShops.filter((shop) => shopIds.includes(shop.id));
            }
        },
        addToCart(state, product) {
            let isAlreadyAdded = state.cartProducts.some((cartProduct) => cartProduct.variation_id === product.variation_id);
            //if (isAlreadyAdded) {
            //    state.cartProducts.map((cartProduct) => {
            //        if (cartProduct.variation_id === product.variation_id)
            //            return (cartProduct.qty = cartProduct.qty + product.qty);
            //    });
            //} else {
            product.selected = true;
            product.is_selected = '1';
            product.max_qty = product.max_qty > 0 ? product.max_qty : Infinity;
            state.cartProducts.push(product);
            //}
        },
        updateQuantity(state, { type, cart_id }) {
            let item = state.cartProducts.find((cartProduct) => cartProduct.cart_id === cart_id);
            if (type == 'plus') {
                state.cartProducts.map((cartProduct) => {
                    if (cartProduct.cart_id === cart_id) return (cartProduct.qty = cartProduct.qty + 1);
                });
            } else if (type == 'minus' && item.qty > item.min_qty) {
                state.cartProducts.map((cartProduct) => {
                    if (cartProduct.cart_id === cart_id) return (cartProduct.qty = cartProduct.qty - 1);
                });
            } else {
                let index = state.cartProducts.map((cartProduct) => cartProduct.cart_id).indexOf(item.cart_id);
                if (index > -1) {
                    state.cartProducts.splice(index, 1);
                }
            }
        },

        removeFromCart(state, id) {
            console.log('cartGroup', state.cartGroups);
            /*
            let index = state.cartProducts.map((cartProduct) => cartProduct.cart_id).indexOf(id);
            if (index > -1) {
                state.cartProducts.splice(index, 1);
            }
            */
        },
        removeMultipleFromCart(state, cart_ids) {
            state.cartProducts = state.cartProducts.filter((cartProduct) => !cart_ids.includes(cartProduct.cart_id));
        },
        resetCart(state) {
            state.cartLoaded = false;
            state.cartProducts = [];
        },
        toggleCartItem(state, { cart_id, status }) {
            let cartItem;
            state.cartProducts.map((item) => {
                if (item.cart_id == cart_id) {
                    cartItem = item;
                    item.is_selected = status ? '1' : '0';
                    return (item.selected = status);
                }
            });

            if (status) {
                state.cartShops.map((shop) => {
                    if (shop.id == cartItem.shop_id) return (shop.selected = status);
                });
            } else if (!state.cartProducts.some((cartProduct) => cartProduct.shop_id == cartItem.shop_id && cartProduct.selected)) {
                state.cartShops.map((shop) => {
                    if (shop.id == cartItem.shop_id) return (shop.selected = status);
                });
            }
        },
        toggleCartShop(state, { shop_id, status }) {
            state.cartShops.map((shop) => {
                // console.log('toggleCartShop', shop);
                if (shop.id == shop_id) {
                    return (shop.selected = status);
                }
            });
            state.cartProducts.map((item) => {
                if (item.shop_id == shop_id && !item.outOfStock) {
                    item.is_selected = status ? '1' : '0';
                    return (item.selected = status);
                }
            });
        },
        saveCoupon(state, { shopId, couponCode, couponDetails, couponDiscount = 0 }) {
            const idx = shopId
                ? state.cartShops.findIndex(shop => shop.id == shopId)
                : (state.cartShops.length > 0 ? 0 : -1);

            if (idx !== -1) {
                // 기존 샵 업데이트: 단일 splice → Vue 2 reactivity 보장
                state.cartShops.splice(idx, 1, {
                    ...state.cartShops[idx],
                    couponCode,
                    couponDetails,
                    couponDiscount,
                });
            } else {
                // 샵이 없는 경우 임시 생성 (cartShops가 비어있거나 ID 불일치 안전망)
                state.cartShops.push({
                    id: shopId || 0,
                    selected: true,
                    min_order: 0,
                    couponCode,
                    couponDetails,
                    couponDiscount,
                });
            }
        },
        setShopCouponDiscount(state, { shop_id, amount }) {
            const shopIndex = state.cartShops.findIndex(shop => shop.id == shop_id);
            if (shopIndex !== -1) {
                // splice로 배열 요소 교체 → Vue 2 반응성 확실 보장
                state.cartShops.splice(shopIndex, 1, {
                    ...state.cartShops[shopIndex],
                    couponDiscount: amount,
                });
            } else {
                // 샵이 존재하지 않으면 임시 샵 객체 생성
                state.cartShops.push({
                    id: shop_id,
                    name: 'Unknown Shop',
                    selected: true,
                    couponCode: null,
                    couponDetails: {},
                    couponDiscount: amount,
                });
            }
        },
        resetCoupon(state, shop_id) {
            if (shop_id) {
                const shopIndex = state.cartShops.findIndex(shop => shop.id == shop_id);
                if (shopIndex !== -1) {
                    state.cartShops.splice(shopIndex, 1, {
                        ...state.cartShops[shopIndex],
                        couponCode: null,
                        couponDetails: {},
                        couponDiscount: 0,
                    });
                }
            } else {
                state.cartShops.forEach((shop, index) => {
                    state.cartShops.splice(index, 1, {
                        ...shop,
                        couponCode: null,
                        couponDetails: {},
                        couponDiscount: 0,
                    });
                });
            }
        },
    },
    actions: {
        async fetchCartProducts({ commit, getters }) {
            if (!getters.cartLoaded || getters.getTempUserId) {
                const res = await Mixin.methods.call_api('post', `carts`, {
                    temp_user_id: getters.getTempUserId,
                });
                if (res.data.success) {
                    commit('setCartGroups', res.data.cart_groups.data);
                    commit('setCartProducts', res.data.cart_items.data);
                    commit('setCartShops', res.data.shops.data);
                }
            }
        },
        async addToCart({ commit, getters, dispatch }, { variation_id, qty }) {
            let temp_user_id = getters.getTempUserId;
            if (!this.getters['auth/isAuthenticated'] && !temp_user_id) {
                temp_user_id = Math.floor(Math.random() * 10000) + new Date().getTime();
                commit('setTempUserId', temp_user_id);
            }
            const res = await Mixin.methods.call_api('post', `carts/add`, {
                variation_id: variation_id,
                qty: qty,
                temp_user_id: temp_user_id,
            });

            if (res.data.success) {
                commit('addToCart', res.data.data);
                commit('updateCartShops', res.data.shop);

                dispatch('proccessCoupon');
            }
        },
        async addToEstimateCart(
            { commit, getters, dispatch },
            { variation_id, qty, price, order_mode, estimate_options, attachments, fileboxes, order_title, order_options, product_options, calculate_options },
        ) {
            let temp_user_id = getters.getTempUserId;
            if (!this.getters['auth/isAuthenticated'] && !temp_user_id) {
                temp_user_id = Math.floor(Math.random() * 10000) + new Date().getTime();
                commit('setTempUserId', temp_user_id);
            }

            // console.log('estimate_options', estimate_options);

            if (estimate_options?.inside2 && !estimate_options.addoptions?.params.is_inside2) {
                delete estimate_options.inside2;
            }

            if (estimate_options?.startend && !estimate_options.addoptions?.params.is_startend) {
                delete estimate_options.startend;
            }

            if (estimate_options?.interleaf && !estimate_options.addoptions?.params.is_interleaf) {
                delete estimate_options.startend;
            }

            let formData = new FormData();
            formData.append('variation_id', variation_id);
            formData.append('qty', qty);
            formData.append('price', price);
            formData.append('temp_user_id', temp_user_id);
            formData.append('order_mode', order_mode);
            formData.append('estimate_options', JSON.stringify(estimate_options));
            formData.append('order_title', order_title);
            formData.append('order_options', JSON.stringify(order_options));
            formData.append('product_options', JSON.stringify(product_options));
            formData.append('calculate_options', JSON.stringify(calculate_options));

            if (attachments) {
                if (Array.isArray(attachments)) {
                    attachments.forEach((file, index) => {
                        formData.append(`attachments[${index}]`, file);
                    });
                } else {
                    formData.append(`attachments[0]`, attachments);
                }
            }
            formData.append('fileboxes', fileboxes);

            const res = await Mixin.methods.call_api('post', `carts/add`, formData, true);

            if (res.data.success) {
                commit('addToCart', res.data.data);
                commit('updateCartShops', res.data.shop);

                dispatch('proccessCoupon');
            }

            return res;
        },
        async updateQuantity({ commit, getters, dispatch }, { type, cart_id }) {
            let cartItem = getters.findCartItemByCartId(cart_id);
            if (type == 'plus' && cartItem.qty + 1 > cartItem.max_qty) {
                Mixin.methods.snack({
                    message: `${i18n.t('you_can_purchase_maximum_quantity')} ${cartItem.max_qty}.`,
                    color: 'red',
                });
                return;
            }
            const res = await Mixin.methods.call_api('post', `carts/change-quantity`, {
                type: type,
                cart_id: cart_id,
                temp_user_id: getters.getTempUserId,
            });
            if (res.data.success) {
                commit('updateQuantity', { type, cart_id });
                commit('updateCartShops');
                dispatch('proccessCoupon');
            } else {
                Mixin.methods.snack({
                    message: res.data.message,
                    color: 'red',
                });
            }
        },
        async removeFromCart({ commit, getters, dispatch }, cart_id) {
            const res = await Mixin.methods.call_api('post', `carts/destroy`, {
                cart_id: cart_id,
                temp_user_id: getters.getTempUserId,
            });
            if (res.data.success) {
                dispatch('fetchCartProducts');
                //commit("removeFromCart", cart_id);
                //commit("updateCartShops");
                //dispatch("proccessCoupon");
            }
        },
        async toggleCartItem({ commit, dispatch }, { cart_id, status }) {
            const res = await Mixin.methods.call_api('post', 'carts/check_item', {
                cart_id: cart_id,
                status: status,
            });
            if (res.data.success) {
                dispatch('fetchCartProducts');

                //commit("toggleCartItem", { cart_id, status });
                //dispatch("proccessCoupon");
            }
        },
        toggleCartShop({ commit, dispatch }, { shop_id, status }) {
            commit('toggleCartShop', { shop_id, status });
            dispatch('proccessCoupon');
        },
        resetCart({ commit, dispatch }) {
            commit('resetCart');
            commit('updateCartShops');
            dispatch('proccessCoupon');
        },
        removeMultipleFromCart({ commit, dispatch }, cart_ids) {
            commit('removeMultipleFromCart', cart_ids);
            commit('updateCartShops');
            dispatch('proccessCoupon');
        },
        saveCoupon({ commit }, { shopId, couponCode, couponDetails, couponDiscount = 0 }) {
            // couponDiscount 포함 단일 commit — proccessCoupon 불필요
            commit('saveCoupon', { shopId, couponCode, couponDetails, couponDiscount });
        },
        resetCoupon({ commit }, shop_id) {
            commit('resetCoupon', shop_id);
            // proccessCoupon 불필요: couponCode가 null 이면 아무것도 재계산 안 함
        },
        proccessCoupon({ commit, getters }) {
            getters.getCartShops.forEach((shop) => {
                if (shop.couponCode) {
                    let total = getters.getShopCartTotalPrice(shop.id);
                    let couponDiscount = 0;

                    // New API format: { type: 'percentage'|'fixed', discount_value, discount_amount }
                    if (shop.couponDetails && shop.couponDetails.type && !shop.couponDetails.coupon_type) {
                        if (shop.couponDetails.type === 'percentage') {
                            couponDiscount = (total * parseFloat(shop.couponDetails.discount_value)) / 100;
                        } else {
                            couponDiscount = parseFloat(shop.couponDetails.discount_value) || 0;
                        }
                    }
                    // Legacy format: { coupon_type: 'product_base'|'cart_base', discount_type, discount, conditions }
                    else if (shop.couponDetails && shop.couponDetails.coupon_type == 'product_base') {
                        let applicableProductIds = shop.couponDetails.conditions.map((item) => parseFloat(item.product_id));
                        let willGetDiscount = false;

                        getters.getShopProductsById(shop.id).forEach((item) => {
                            if (item.selected && applicableProductIds.includes(item.product_id)) {
                                willGetDiscount = true;
                                if (shop.couponDetails.discount_type == 'percent') {
                                    couponDiscount += ((item.dicounted_price * parseFloat(shop.couponDetails.discount)) / 100) * item.qty;
                                } else if (shop.couponDetails.discount_type == 'amount') {
                                    couponDiscount += item.qty * parseFloat(shop.couponDetails.discount);
                                }
                            }
                        });

                        if (!willGetDiscount) {
                            Mixin.methods.snack({
                                message: i18n.t('applied_coupon_code_is_no_applicable_for_your_selected_cart_products'),
                                color: 'red',
                            });
                        }
                    } else if (shop.couponDetails && shop.couponDetails.coupon_type == 'cart_base') {
                        if (total >= parseFloat(shop.couponDetails.conditions.min_buy)) {
                            if (shop.couponDetails.discount_type == 'percent') {
                                couponDiscount += (total * parseFloat(shop.couponDetails.discount)) / 100;
                                if (couponDiscount > parseFloat(shop.couponDetails.conditions.max_discount)) {
                                    couponDiscount = parseFloat(shop.couponDetails.conditions.max_discount);
                                }
                            } else if (shop.couponDetails.discount_type == 'amount') {
                                couponDiscount += shop.couponDetails.discount;
                            }
                        } else {
                            Mixin.methods.snack({
                                message: `${i18n.t('minimum_order_total_of')} ${Mixin.methods.format_price(parseFloat(shop.couponDetails.conditions.min_buy))} ${i18n.t(
                                    'is_required_to_use_applied_coupon_code',
                                )}`,
                                color: 'red',
                            });
                        }
                    }

                    commit('setShopCouponDiscount', { amount: couponDiscount, shop_id: shop.id });
                }
            });
        },
    },
};
